import {
    _createUserJson,
    _createGroupJson,
    commonUpdateGroupList,
    groupMsgDisturb,
    asyncQueueFlush,
    stuSortUserOrGroup,
} from "@/utils/groupChat.js";
import store from "@/store";
import _ from "lodash";
import CommonUtil from "@/assets/js/CommonUtil";
import { subscribeMsgNotice, singleCase, randomVal } from "@/utils/tool";

const commonUtil = new CommonUtil();
/**
 * @description 导出企业聊天相关的mutations
 */
export default {

    /**
     * @author lihh
     * @description 初期化获取用户 群组未读消息等
     * @param state
     * @param payload
     */
    initGetUnreadMsgInfo(state, payload) {
        const { singleUnreadInfo, groupUnreadInfo } = payload;
        if ( singleUnreadInfo.length > 0 ) state.singleUnreadInfo = singleUnreadInfo;
        if ( groupUnreadInfo.length > 0 ) state.groupUnreadInfo = groupUnreadInfo;
    },

    updateUserList(state, payload) {
        const { userListStu, type } = payload;
        state.userListStu[type] = userListStu;
    },
    // 加入群聊
    currentGAllUserStu(state, payload) {
        // 判断是否数组 还是对象  yes ? 表示重新查询 反之 单个添加用户
        if ( Array.isArray(payload) ) {
            state.currentGAllUser = payload;
        } else {
            state.currentGAllUser.push(payload);
        }
    },

    // 离开群聊(删除并更新群列表)
    removeCGroupUserStu(state, payload) {
        // 解构数据
        const { groupId } = payload;
        // 表示下标
        let index = - 1;
        state.userListStu.groupUserList.forEach((item, key) => {
            if ( groupId === item.groupId ) {
                index = key;
            }
        });
        // 判断是否找到
        if ( index === - 1 ) {
            return;
        }

        // 删除数据
        state.userListStu.groupUserList.splice(index, 1);
    },

    updateJob(state, payload) {
        // 解构数据
        const { name, positionId,isSelf = true } = payload;
        // 表示当前用户
        const currentUser = state.userListStu.contactUserList.filter(item => item["name"] == name);

        // 判断用户是否存在
        if ( currentUser.length <= 0 ) return;
        currentUser[0]["positionId"] = positionId;
        // 更新用户切换的职位id
        let currentId = localStorage.getItem("currentId");
        if ( name == currentId && isSelf ) subscribeMsgNotice("pc_call", positionId, true);
        if (name == currentId && !isSelf) subscribeMsgNotice("jobid_call", positionId, true);
    },

    /**
     * @author lihh
     * @description 表示设置群聊信息
     * @param {*} state 表示数据
     * @param {*} payload 传递数据
     */
    settingGroupsInfo(state, payload) {
        // 表示兄弟的state
        state = store.state.chat;
        // 解构数据
        const { result } = payload;
        /* 对数据直接进行覆盖 */
        if ( !singleCase.__initQueryGroupState__ ) {
            singleCase.__initQueryGroupState__ = 1;
            singleCase.__initQueryGroupValue__ = {};
        }
        const newGroups = result.map(item => _createGroupJson(item));
        state.userListStu.groupUserList = newGroups.slice();
    },

    /**
     * @author lihh
     * @description 更新用户以及群聊的数量
     * @param state
     * @param payload
     */
    editUserOrGroupUnreadNum(state, payload) {
        const { type = "contact", id } = payload,
            target = type === "contact" ? state.userListStu.contactUserList : state.userListStu.groupUserList,
            keyName = type === "contact" ? "name" : "groupId",
            localIndex = (target || []).findIndex(item => item[keyName] === id);
        if ( localIndex === - 1 ) return;
        target[localIndex]["unreadNum"] = 0;
        if ( singleCase.__initQueryGroupState__ && type !== "contact" ) singleCase.__initQueryGroupValue__[id] = 0;
    },

    /**
     * @author lihh
     * @description 编辑hr答疑数量 以及是否查询
     * @param state 表示消息状态
     * @param payload 表示传递数据
     */
    editHrQuestionNumRecords(state, payload) {
        const { id = "", isOpen, number } = payload;
        if ( !id ) return;
        const target = state.hrQuestionNumRecords[id] || {};
        if ( number ) target["number"] = number;
        if ( typeof isOpen !== "undefined" ) target["isOpen"] = isOpen;
        state.hrQuestionNumRecords[id] = { ...target };
    },

    /**
     * @author lihh
     * @description 为了显示群聊的顺序
     * @param state 表示缓存中的数据
     * @param payload id 表示群聊id
     */
    onlyEditGroupDisplayOrder(state, payload) {
        const target = state.userListStu.groupUserList,
            { id } = payload,
            localIndex = target.findIndex(item => item.groupId === id);
        if ( localIndex === - 1 || localIndex === 0 ) return;
        const source = target.splice(localIndex, 1)[0];
        commonUpdateGroupList.call(this, state, source);
    },

    /**
     * @author lihh
     * @description 为了显示单聊的顺序
     * @param state 表示缓存中的数据
     * @param payload id 表示群聊id
     */
    onlyEditChatDisplayOrder(state, payload) {
        const target = state.userListStu.contactUserList,
            { id } = payload,
            localIndex = target.findIndex(item => item.name === id);
        if ( localIndex === - 1 ) return;
        // const source = target.splice(localIndex, 1)[0];
        stuSortUserOrGroup("contact", id);
    },

    /**
     * @author lihh
     * @description 将查询的数据 跟环信的数据进行对比差分输出 (目前仅限单聊 群聊 因为有置顶 暂时不需要)
     * @param state
     * @param payload
     */
    dataCompareOutput(state, payload) {
        /* 解构数据 */
        const { userInfo = [], callback, preCount = 11 } = payload;
        /* 筛选单独的id */
        const newUserIds = userInfo.map(item => item["name"]);

        /* 防止数据过多 分为异步执行任务(是消息异步 但是用户同步) */
        Promise.resolve().then(() => {
            return new Promise((resolve, reject) => {
                if ( userInfo.length <= preCount ) {
                    callback(userInfo, true, newUserIds);
                    reject();
                } else {
                    callback(userInfo, true, newUserIds.slice(0, preCount));
                    const timer = setTimeout(() => {
                        resolve(newUserIds.slice(preCount));
                        clearTimeout(timer);
                    }, 3000);
                }
            });
        }).then((ids) => {
            const size = 5,
                result = [];
            let i = 0;
            for ( ; i < ids.length; i += size ) {
                result.push(ids.slice(i, i + size));
            }

            return result.reduce((pre, cur) => {
                return pre.then(() => {
                    return new Promise(resolve => {
                        let timer = setTimeout(() => {
                            clearTimeout(timer);
                            callback(userInfo, false, cur);
                            resolve();
                        }, 1500);
                    });
                });
            }, Promise.resolve());
        }).catch(() => {
            console.log("-- 任务执行结束了 --");
        });
    },

    // 退出清除数据
    clearUserList(state) {
        /* 退出环信登录 */
        const userInfo = localStorage.getItem("userInfo");
        localStorage.removeItem("userInfo");
        if ( window.WebIM && window.WebIM.conn && userInfo ) {
            const conn = window.WebIM.conn;
            if ( conn.close && typeof conn.close === "function" ) {
                conn.close();
            }
        }
        //清除聊天下一页的状态
        store.commit("clearChatAboutAllStatus");
        localStorage.removeItem("91SingleChat_stu");
    },

    /**
     * @author lihh
     * @description 清除所有的聊天相关的状态
     * @param state
     */
    clearChatAboutAllStatus(state) {
        const clearFor = (list, data) => Object.keys(list).forEach(keyName => list[keyName] = data);
        const oldState = store.state;
        state = store.state.chat;
        /* 用户列表 */
        clearFor(state.userListStu, []);
        /* 消息列表 */
        clearFor(state.msgListStu, {});
        /* 单聊以及群聊未读消息 */
        state.singleUnreadInfo = state.groupUnreadInfo = [];
        /* 单聊群聊分页 */
        oldState.groupNextPage = oldState.singleNextPage = [];
        /* 加载中的状态 */
        oldState.moreMsgLoadingStatus = false;
        /* 当前所有的消息 d*/
        state.currentMsgs = [];
        /* 当前群成员*/
        state.currentGAllUser = [];
        if ( WebIM.conn.mr_cache ) WebIM.conn.mr_cache = [];
    },

    //清除所有的用户和群聊
    clearAllUserOrGroupStu(state) {
        const oldState = store.state;
        // 表示兄弟的state
        state = store.state.chat;
        const { contactUserList, groupUserList } = state.userListStu,
            userList = contactUserList.map(item => item.name || item.userName),
            groupList = groupUserList.map(item => item.groupId);
        /* 先删除分页信息 */
        userList.forEach(id => {
            const localIndex = oldState["singleNextPage"].findIndex(item => item.name === id);
            if ( localIndex === - 1 ) return true;
            oldState["singleNextPage"].splice(localIndex, 1);
        });
        groupList.forEach(groupId => {
            const localIndex = oldState["groupNextPage"].findIndex(item => item.name === groupId);
            if ( localIndex === - 1 ) return true;
            oldState["groupNextPage"].splice(localIndex, 1);
        });
        /* 再删除 聊天用户 群用户 */
        state.userListStu.contactUserList = [];
        state.userListStu.groupUserList = [];
        state.msgListStu.contact = {};
        state.msgListStu.group = {};
        if ( WebIM.conn.mr_cache ) WebIM.conn.mr_cache = [];
    },

    /**
     * @author lihh
     * @description 清空历史消息
     * @param {*} state 表示状态
     */
    clearstuHistoryMsg(state, payload) {
        // 表示兄弟的state
        state = store.state.chat;
        /* 判断是单个删除列表  还是一括删除 */
        if ( payload ) {
            state.msgListStu[payload === "singleChat" ? "contact" : "group"] = {};
        } else {
            Object.keys(state.msgListStu).forEach(item => state.msgListStu[item] = {});
        }
    },

    /**
     * @author lihh
     * @description 为了实现1v1 是否收到通话邀请
     * @param {*} state
     * @param {*} payload
     */
    noticeCall(state, payload) {
        state.noticeCallMsg = payload;
    },

    // 表示删除用户
    deleteUserStu(state, payload) {
        // 解构数据
        const { name } = payload;
        // 表示选中索引
        let selectedIndex = - 1;

        // 获取用户下标
        state.userListStu.contactUserList.forEach((item, index) => {

            // 判断userid是否一致
            if ( item.name == name ) {
                selectedIndex = index;
            }
            // 判断是否找到
            if ( selectedIndex === - 1 ) {
                return;
            }
        });
        // 删除用户
        state.userListStu.contactUserList.splice(selectedIndex, 1);
        // 删除消息
        Reflect.deleteProperty(state.msgListStu.contact, name);
    },

    /**
     * @author lihh
     * @description 对发送消息的用户进行排序
     * @param {*} state 表示状态
     * @param {*} payload 数据
     */
    sortUserStuList(state, payload) {
        /* 根据不同的场合解构不同的数据 */
        const { addUser = false } = payload;
        let jobId = null;
        if ( addUser ) {
            payload = payload["resultData"];
        } else {
            jobId = payload.otherOptions && payload.otherOptions.jobId;
            payload = payload.name;
        }
        // 表示兄弟的state
        state = store.state.chat;
        const contactUserList = state.userListStu.contactUserList;
        // 判断是否有用户
        if ( typeof payload === "string" ) {
            // 获取下标
            const localIndex = contactUserList.findIndex(item => item.name === payload);
            if ( localIndex === - 1 && !localIndex ) {
                return;
            }
            // 原来的数据
            const originalItem = contactUserList[localIndex];
            if ( jobId && jobId !== originalItem["positionId"] ) originalItem["positionId"] = jobId;
            contactUserList.splice(localIndex, 1);
            contactUserList.unshift(originalItem);
            return;
        }

        // 表示新添加用户
        const { nickName: nick, headImg, recordId, positionId, userName: name, userName,companyPosition,companyName,isInterest,isFirst } = payload;
        let newObj = _createUserJson({ nick, name, headImg, positionId, recordId, userName,companyPosition,companyName,isInterest,isFirst });
        /*
          如果是添加新用户 按理说不会有用户存在 但是如果是退出登录后 重新登录 环信会推送未读消息 避免重复添加
      */
        const localIndex = contactUserList.findIndex(item => item.name === newObj.name);
        if ( localIndex === - 1 ) contactUserList.unshift(newObj);
    },

    /**
     * @author lihh
     * @description 对发送消息的群 或是 接受消息的群进行排序
     * @param state 表示vuex状态
     * @param payload 表示传递的数据
     */
    sortGroupStuList(state, payload) {

        // 表示兄弟的state
        state = store.state.chat;
        // 解构数据
        const { groupId } = payload;
        // 表示下标 以及元数据
        let index = - 1;
        let originalData = null;

        // 获取当前聊天的用户
        state.userListStu.groupUserList.forEach((item, key) => {
            if ( item.groupId === groupId ) {
                index = key;
                originalData = item;
            }
        });

        if ( index === - 1 ) {
            return;
        }
        // 解构数据
        const { isDisturb } = originalData;
        // 判断是否消息免打扰  如果是免打扰 直接不做任何操作
        if ( isDisturb == 1 ) {
            return;
        }

        // 判断是否置顶 如果是特殊情况置顶了  就处理特殊情况
        state.userListStu.groupUserList.splice(index, 1);
        // 调换顺序
        commonUpdateGroupList.call(this, state, originalData);
    },

    /**
     * @author lihh
     * @description 主要针对从别的页面 点击按钮 迁移过来的用户 直接跳转到聊天页面
     * @param {*} state 表示缓存中的状态
     * @param {*} payload 表示新增用户数据
     */

    skipPageAddSingleUserStu(state, payload) {
        const contactUserList = state.userListStu.contactUserList;

        /* 添加新用户 */
        const { nickName: nick, headImg, recordId, positionId, userName: name, userName,companyPosition,companyName,isInterest,isFirst } = payload;
        let newObj = _createUserJson({ nick, name, headImg, positionId, recordId, userName,companyPosition,companyName,isInterest,isFirst });
        contactUserList.unshift(newObj);
    },

    /**
     * @author lihh
     * @description 主要针对从别的页面 点击按钮 迁移过来的用户 直接跳转到群聊天页面
     * @param {*} state 表示缓存中的状态
     * @param {*} payload 表示新增群信息
     */

    skipPageAddGroupStu(state, payload) {
        if ( !state.userListStu.groupUserList ) state.userListStu.groupUserList = [];
        const groupUserList = state.userListStu.groupUserList;
        /* 添加新群 */
        const { groupHeadicon, groupName, groupId: hxGroupId, isDisturb, isTop, type, isOwner, nickName } = payload;
        let newObj = _createGroupJson({
            groupHeadicon,
            groupName,
            hxGroupId,
            isDisturb,
            isTop,
            type,
            isOwner,
            nickName,
        });
        groupUserList.unshift(newObj);
    },

    /*
    * desc 获取HR的个人信息
    */

    getHrInfos(state, payload) {
        state.hrInfos = commonUtil._updateMoneyFormat(payload);
    },

    /**
     * @author lihh
     * @description 强制更新计算属性
     * @param state 表示传递的数据
     */
    editComputeForceUpdateNumber(state) {
        state.computeForceUpdateNum = randomVal();
    },

    // 点击不合适修改列表状态
    editUserStatus(state, payload) {
      const target = state.userListStu.contactUserList,
      {name} = payload,
      localIndex = target.findIndex(item => item.name === name);
      if ( localIndex === - 1 ) return;
      target[localIndex]["isInterest"] = '2';
    },

    /**
     * @author lihh
     * @description 更新群消息
     * @param state 表示数据状态
     * @param payload 表示需要更新的数据
     */
    updateGroupInfo(state, payload) {
        // 解构数据
        const { groupId } = payload;
        // 删除字段
        Reflect.deleteProperty(payload, "groupId");
        // 获取索引
        let index = - 1;
        let originalData = null;
        state.userListStu.groupUserList.forEach((item, key) => {
            if ( item.groupId === groupId ) {
                index = key;
                originalData = item;
                return;
            }
        });

        if ( index === - 1 ) {
            return;
        }
        // 表示更新后的数据
        const afterData = { ...originalData, ...payload };
        // 修改数据
        state.userListStu.groupUserList.splice(index, 1);
        // 判断是否是消息免打扰处理 如果是消息免打扰不会处理别的
        if ( Reflect.has(payload, "isDisturb") ) {
            // 插入到原来的职位 其实就是为了触发watcher
            state.userListStu.groupUserList.splice(index, 0, afterData);
            return;
        }

        // 调换顺序
        commonUpdateGroupList.call(this, state, afterData);
    },

    updateMsgList(state, payload) {
        // console.log(payload)
        const { chatType, chatId, msg, from, bySelf, type, to, id, langType = "1" } = payload;
        // 邀请信息
        let inviteInfo = null;
        //  11(面试邀请)  进行json转换
        if ( langType == "11" ) inviteInfo = JSON.parse(msg);
        let userInfo = localStorage.getItem("userInfo");
        if ( !userInfo ) return;
        const loginUser = JSON.parse(userInfo)["userId"];
        // 获取聊天用户
        let params = {};
        params["id"] = localStorage.getItem("currentId") || "";
        let status = "unread";
        if ( payload.chatType == "contact" ) {
            if ( params.id == payload.from ) {
                status = "read";
            }
        } else if ( payload.chatType == "group" ) {
            if ( params.id == payload.chatId || groupMsgDisturb(payload.chatId || "0") ) {
                status = "read";
            }
        }

        if ( !state.msgListStu[chatType][chatId] ) {
            state.msgListStu[chatType][chatId] = [ {
                msg,
                bySelf,
                inviteInfo,
                type: type || "",
                from: from,
                mid: id,
                status: status,
                ...payload,
            } ];
        } else {
            state.msgListStu[chatType][chatId].push({
                msg,
                bySelf,
                inviteInfo,
                type: type || "",
                from: from,
                mid: id,
                status,
                ...payload,
            });
            state.msgListStu[chatType][chatId] = state.msgListStu[chatType][chatId].sort((a, b) => {
                return a.time - b.time;
            });

        }

        /* 此逻辑为了多端消息同步 */
        if ( payload.from === loginUser && to ) {
            const msgInfo = { msg, inviteInfo, type, mid: id, status, ...payload },
                target = state.msgListStu[chatType];
            !target[to] ? target[to] = { ...msgInfo, bySelf: true } : target[to].push({ ...msgInfo, bySelf: true });
        }

        let currentId = localStorage.getItem("currentId");
        if ( currentId == chatId ) {
            state.currentMsgs = Object.assign({}, state.msgListStu[chatType][params.id || chatId]); // 这里params.id在路由跳转的时候会undefind，取chatId兼容
        }

        // if ( chatType === "contact" && bySelf ) { // 单聊消息去重处理
        //     state.currentMsgs = _.uniqBy(state.msgListStu[chatType][chatId], "mid");
        // }

        state.msgListStu = Object.assign({}, state.msgListStu);
    },
    updateCurrentMsgList(state, messages) {
        state.currentMsgs = messages;
    },
    updateMessageMid(state, message) {
        const { id, mid } = message;
        let name = "contact";
        Object.keys(state.msgListStu[name]).forEach((user) => {
            // console.log(state.msgList[name][user]);
            if ( state.msgListStu[name][user].length ) {
                state.msgListStu[name][user].forEach((msg) => {
                    if ( msg.mid == id ) {
                        msg.mid = mid;
                    }
                });
            }
        });
    },

    /**
     * @author lihh
     * @description 删除群聊中的其他的用户
     * @param state 表示vuex的状态
     * @param payload 表示传递数据
     */
    delCGroupOtherUser(state, payload) {
        // 解构数据
        const { userId } = payload;
        // 表示下标
        let index = - 1;
        state.currentGAllUser.forEach((item, key) => {
            if ( userId === item.id ) {
                index = key;
            }
        });
        // 判断是否找到
        if ( index === - 1 ) {
            return;
        }

        // 删除数据
        state.currentGAllUser.splice(index, 1);
    },

    /**
     * @author lihh
     * @description 更新消息的已读未读状态
     * @param state store的 状态
     * @param message 表示传递的消息
     */
    updateMessageStatus(state, message) {
        /* self true 读取我自己的消息 反之 对方发的消息 */
        const { id, mid, action, readUser, name = "contact", self = true, isRecall = false } = message,
            keys = Object.keys(state.msgListStu[name]);
            let i = 0,
            user = null;

        /* 如果是撤回 单独处理 */
        if ( isRecall ) {
            const loopHandleRecallMsg = (name, callback) => {
                const keys = Object.keys(state.msgListStu[name]);
                let i = 0;
                for ( ; i < keys.length; i ++ ) {
                    state.msgListStu[name][keys[i]].forEach(callback);
                }
            };
            /* 修改撤回消息状态的回调 */
            const callback = msg => {
                if ( msg.mid == mid && msg.status !== "recall" ) {
                    msg.status = message.status;
                    msg.msg = message.msg;
                    msg.langType = message.langType;
                }
            };
            /* 修改引用消息撤回的回调 */
            const quoteMsgCallback = msg => {
                if ( msg.quoteMid && msg.quoteMid === mid) {
                    msg.quoteMsg = "该引用消息被撤回";
                }
            }
            loopHandleRecallMsg("group", callback);
            loopHandleRecallMsg("contact", callback);
            loopHandleRecallMsg("group", quoteMsgCallback);
            loopHandleRecallMsg("contact", quoteMsgCallback);
            return;
        }

        for ( ; i < keys.length; i ++ ) {
            user = keys[i];
            if ( action == "oneUserReadMsgs" ) {
                if ( state.msgListStu[name][readUser] ) {
                    state.msgListStu[name][readUser].forEach((msg) => {
                        if ( msg.status != "recall" && msg.bySelf === self ) {
                            msg.status = "read";
                            asyncQueueFlush(() => store.commit("editComputeForceUpdateNumber"));
                        }
                    });
                    return;
                }
            } else if ( state.msgListStu[name][user].length ) {
                state.msgListStu[name][user].forEach((msg) => {
                    if ( action === "readMsgs" && !msg.bySelf ) {
                        if ( msg.status != "recall" ) {
                            msg.status = "read";
                        }
                    } else if ( msg.mid == id || msg.mid == mid ) {
                        msg.status = message.status;
                        if ( message.msg ) {
                            msg.msg = message.msg;
                            if ( msg.langType ) msg.langType = message.langType;
                        }
                    }
                });
            }
        }
    },
};



// WEBPACK FOOTER //
// ./src/store/stu/mutations.js